import { ReactElement, useState } from 'react';
import { Button, Grid, Paper } from '@mui/material';
import { IAuditLog } from '~/services/api/auditLogs/types';
import Table from '../../AuditLogs/Table';
import { initialSort } from '../../AuditLogs/Table/constants';
import styles from './RecentActivity.module.scss';
import AuditLogs from '../../AuditLogs';
import Modal from '~/ui/components/common/Modal';

interface IProps {
  auditLogs: IAuditLog[];
}

const RecentActivity = ({ auditLogs }: IProps): ReactElement => {
  const [showPopup, setShowPopup] = useState(false);

  return (
    <Paper elevation={3}>
      <Table items={auditLogs} isWhite sort={initialSort} setSort={null} />
      <Grid container justifyContent="center">
        <Grid item>
          <Button
            className={styles.showMore}
            variant="text"
            color="primary"
            onClick={() => setShowPopup(true)}
          >
            Show More
          </Button>
        </Grid>
      </Grid>
      {showPopup && (
        <Modal
          open
          className={styles.auditLogsModal}
          maxWidth="lg"
          onClose={() => setShowPopup(false)}
          title="Audit Logs"
          contentIdAttribute="scrollableModal"
        >
          <AuditLogs scrollableTarget="scrollableModal" />
        </Modal>
      )}
    </Paper>
  );
};

export default RecentActivity;
